// extracted by mini-css-extract-plugin
module.exports = {"sliderArrows":"styles_sliderArrows__15fTJ"};